export const BLANK_COMPANY_CERTIFICATION = {
  expirationDate: "",
  effectiveDate: "",
  image: null as any,
}
export const HISTORICAL_AMOUNT_OF_CERTIFICATIONS = 8

export const CERTIFICATION_ALLOWED_TYPES_LABEL = "PDF, PNG, JPG or JPEG"
